const toastr = require("toastr");

const Pagseguro = function(){
  var priv = {};
  var pub = {};

  priv.set_sessions = function(session_id){
    priv.session = PagSeguroDirectPayment.setSessionId(session_id);
    // priv.sender_hash = ;
  }

  priv.get_card_brand = function(){
    // https://github.com/pagseguro/pagseguro-sdk-ruby/blob/master/docs/transparent_checkout.md#obter-bandeira-do-cart%C3%A3o-de-cr%C3%A9dito

    PagSeguroDirectPayment.getBrand({
     cardBin: $("input#transaction_card_number").val(),
     success: function (response) {
       //bandeira encontrada
     },
     error: function (response) {
       //tratamento do erro
     },
     complete: function (response) {
       //tratamento comum para todas chamadas
     }
    });
  }

  priv.get_card_token = function(){
    var expirationCard = $("input#transaction_card_expiration").val().split('/')
    var params = {
      cardNumber: $("input#transaction_card_number").cleanVal(),
      cvv: $("input#transaction_card_cvv").val(),
      expirationMonth: expirationCard[0],
      expirationYear: expirationCard[1],
      success: function (response) {
        priv.card_token = response.card.token //token gerado, esse deve ser usado na chamada da API do Checkout Transparente
        $('input#transaction_credit_card_token').val(priv.card_token);
        $('input#transaction_sender_hash').val(PagSeguroDirectPayment.getSenderHash());

        $('input#transaction_card_number').remove();
        $('input#transaction_card_expiration').remove();
        $('input#transaction_card_cvv').remove();

        $('form').unbind('submit').trigger('submit');
        $('form').bind('submit', priv.validateSubmit);
      },
      error: function (response) {
        //tratamento do erro
        console.log("ERROR: ", response);

        window.showToast([['error', 'Cartão Inválido.']]);
      },
      complete: function (response) {
        // console.log("COMPLETE: ", response)
        //tratamento comum para todas chamadas

      }
    }

    // parâmetro opcional para qualquer chamada
    // if($("input#bandeira").val() !== '') {
    //   params.brand = $("input#bandeira").val();
    // }

    return PagSeguroDirectPayment.createCardToken(params);
  }

  priv.switch_payment_method = function(e){
    priv.payment_method = e.currentTarget.value;

    if (e.currentTarget.value == 'credit_card'){
	  $('#other_installment').hide()
      $('#credit_card_row').show()
	  $('#credit_card_installment').show()
    } else {
      $('#credit_card_row').hide()
	  $('#credit_card_installment').hide()
	  $('#other_installment').show()
    }
  }

  // pub.setCardToken = function(){
  //   priv.get_card_token()
  // }

  priv.validateSubmit = function(e){
    e.preventDefault();
    e.stopPropagation();
	if ($('#transaction_person_attributes_name').val().trim().indexOf(" ") < 0) {
		toastr.error('Campo nome, deve conter nome e sobrenome!.', 'Erro!');
		return false;
	}
    if (priv.payment_method == 'credit_card'){
      priv.get_card_token();
      return false
    }

    $('input#transaction_sender_hash').val(PagSeguroDirectPayment.getSenderHash());
    $('form').unbind('submit').trigger('submit');

    return false
  }

  pub.init = function(session_id){
    priv.set_sessions(session_id);

    $('form').on('submit', priv.validateSubmit);
    $('#transaction_card_number').mask("0000 0000 0000 0000");
    $('#transaction_card_expiration').mask("00/0000");
    $('#transaction_person_attributes_birth_at').mask("00/00/0000");
    $('#transaction_payment_method').on('change', priv.switch_payment_method).trigger('change');
	$('#transaction_card_expiration').blur(function() {
		var exp = $('#transaction_card_expiration').val();
		if (exp.length < 7) {
			$('#transaction_card_expiration').val(exp.replace("/","/20"));
		}
	});

	$('#btn_help')[0].href = $('#btn_help')[0].href.replace('http://help/?', atob("aHR0cHM6Ly93YS5tZS81NTU0OTE0Njg4MTU/dGV4dD0="));

  }

  return pub;
}()

export default Pagseguro;
